import { ChangeEvent } from 'react';

interface InputProps {
    label: string,
    placeholder: string,
    className?: string,
    rows?: number,
    value?: string,
    onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void,
    error?: string,
}

const Input = ({label, placeholder, className="", rows=1, value, onChange, error}: InputProps) => {
  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <label className="text-lg font-medium">{label}</label>
      {rows ? (
        <textarea
          placeholder={placeholder}
          className={`border ${error ? 'border-red-500' : 'border-gray-300'} rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-primary-blue`}
          rows={rows}
          value={value}
          onChange={onChange}
        />
      ) : (
        <input
          type="text"
          placeholder={placeholder}
          className={`border ${error ? 'border-red-500' : 'border-gray-300'} rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-primary-blue`}
          value={value}
          onChange={onChange}
        />
      )}
      {error && <p className="text-red-500 text-sm">{error}</p>}
    </div>
  )
}

export default Input